import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    /**
     * Viene salvata la request in stringa. Visto che mettiamo in cache solo le "GET" si potrebbe salvare soltanto l'url della request.
     * Ma in questo modo siamo sicuri che la richiesta fatta non ha duplicati (poichè il discriminante non è solo l'URL).
     */
    private cache: Map<string, HttpResponse<unknown>> = new Map();

    constructor() {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const requestString = JSON.stringify(request);
        const shouldCache = request.headers.get('cache-data') === 'true';
        const shouldRefresh = request.headers.get('refresh-data') === 'true';

        if (request.method !== 'GET' || (request.method === 'GET' && shouldCache !== true)) {
            // La request non viene messa in cache
            return next.handle(request);
        }

        if (shouldRefresh) {
            this.cache.delete(requestString);
        }

        const cachedResponse: HttpResponse<unknown> = this.cache.get(requestString);
        if (cachedResponse) {
            return of(cachedResponse);
        } else {
            return next.handle(request).pipe(
                tap(stateEvent => {
                    if (stateEvent instanceof HttpResponse) {
                        this.cache.set(requestString, stateEvent);
                    }
                })
            );
        }
    }
}
